import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Card, CardContent, IconButton, Typography, useMediaQuery, useTheme, Modal, Box, SwipeableDrawer, Drawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { motion } from "motion/react"

import DurationIntensity from "../plan_components/DurationIntensity"
import AverageIsUgly from "../plan_components/AverageIsUgly";
import NotPersonal from "../plan_components/NotPersonal";

import { useNavigate, useLocation } from "react-router-dom";


const journalCards = [
  {
    id: 1,
    drawerUrl: "average-is-ugly",
    title: "Average Is Ugly?",
    goal: "Plan: Understand why you have these criteria",
    glowStyle: {
      background: `
        radial-gradient(
          circle at 25% 20%,
          rgba(255, 0, 132, 0.8) 0%,
          rgba(255, 100, 141, 0.4) 35%,
          rgba(255, 177, 160, 0.18) 65%,
          rgba(255, 200, 224, 0.08) 85%,
          transparent 100%
        )
      `,
    },
    visualComponent: <DurationIntensity />,
    drawerComponent: AverageIsUgly,
    themeColor: 'rgba(255, 114, 173, 1)',
  },
  {
    id: 2,
    drawerUrl: "its-not-personal",
    title: "It's Not Personal, It's Dating",
    goal: "Plan: Identify the type of love you're seeking",
    glowStyle: {
      background: `
        radial-gradient(
          circle at 25% 20%,
          rgba(0, 166, 255, 0.8) 0%,
          rgba(100, 198, 255, 0.4) 35%,
          rgba(160, 225, 255, 0.18) 65%,
          rgba(200, 239, 255, 0.08) 85%,
          transparent 100%
        )
      `,
    },
    visualComponent: <DurationIntensity />,
    drawerComponent: NotPersonal,
    themeColor: 'rgba(0, 166, 255, 0.8)',
  },
  {
    id: 3,
    title: "Love in Terms of Duration and Intensity",
    drawerUrl: "test1",
    goal: "Plan: Identify what type of love you're seeking",
    glowStyle: {
      background: `
        radial-gradient(
          circle at 25% 20%,
          rgba(255, 153, 0, 0.8) 0%,
          rgba(255, 180, 100, 0.4) 35%,
          rgba(255, 210, 160, 0.18) 65%,
          rgba(255, 230, 200, 0.08) 85%,
          transparent 100%
        )
      `,
    },
    visualComponent: <DurationIntensity />,
    // drawerComponent: DurationIntensity2,
  },
  // Add more cards here
];

export function JournalCard({
  activePlanDrawer,
  setActivePlanDrawer,
  cardId,
  drawerUrl,
  title,
  date,
  preview,
  fullText,
  goal,
  visualComponent,
  drawerComponent,
  glowStyle,
}) {
  const [showOverlay, setShowOverlay] = useState(false);
  const cardRef = useRef(null);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldAnimate(true);
        } else {
          setShouldAnimate(false); // Reset when leaving viewport
        }
      },
      { threshold: 1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);


  return (
    <>

      <Card
        ref={cardRef}
        onClick={() => setActivePlanDrawer(drawerUrl)}
        style={{
          width: '100%',
          cursor: 'pointer',
          overflow: 'hidden',
          boxShadow: '0px 2px 8px rgba(0,0,0,0.2)',
          position: 'relative',
          borderRadius: '20px',
          visibility: showOverlay ? 'hidden' : 'visible',
        }}
      >
        {/* Glow effect */}
        {glowStyle && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              overflow: "visible",
              pointerEvents: "none",
              zIndex: 0,
            }}
          >
            <motion.div
              initial={{ opacity: 0, x: -100, y: -100 }}
              animate={shouldAnimate
                ? { opacity: 1, x: 0, y: 0 }
                : { opacity: 0, x: -100, y: -100 }
              }
              transition={{ duration: 0.8, ease: "easeOut" }}
              style={{
                position: "absolute",
                top: "-200px",
                left: "-100px",
                width: "600px",
                height: "600px",
                borderRadius: "50%",
                filter: "blur(100px)",
                pointerEvents: "none",
                zIndex: 0,
                ...glowStyle,
              }}
            />
          </div>
        )}

        <CardContent style={{ position: 'relative', padding: 0, zIndex: 1 }}>

          {/* Visual */}
          <div
            style={{
              height: '200px',
              // marginBottom: '16px',
              pointerEvents: 'none',
              touchAction: 'none',
            }}
          >
            {visualComponent}
          </div>
          <div style={{ padding: '4px 17px 8px 17px' }}>

            {/* Title */}
            <h2
              style={{
                fontSize: '22px',
                fontWeight: 600,
                marginTop: '2px',
                marginBottom: '2px',
              }}
            >
              {title}
            </h2>

            {/* Goal Text */}
            {/* <p className='planGoal'>
              {goal}
            </p> */}

            {/* Divider
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '5px 0',
                marginBottom: '5px',
              }}
            >
              <div
                style={{
                  width: '70%',
                  height: '1px',
                  backgroundColor: '#e0e0e0',
                }}
              />
            </div> */}


          </div>
        </CardContent>
      </Card>
    </>
  );
}

export default function Discovery({ activePlanDrawer, setActivePlanDrawer }) {

//   const location = useLocation();
// const navigate = useNavigate();

// // 🟢 On load or URL change — open the correct drawer
// useEffect(() => {
//   const params = new URLSearchParams(location.search);
//   const drawerParam = params.get("drawer");
  
//   if (drawerParam) {
//     // find matching card by URL name
//     const matchingCard = journalCards.find(
//       (card) => card.drawerUrl === drawerParam
//     );
//     if (matchingCard) {
//       setActivePlanDrawer(matchingCard.id);
//     }
//   } else {
//     setActivePlanDrawer(null);
//   }
// }, [location.search]);

// // 🟢 When drawer state changes — update the URL (no reload)
// useEffect(() => {
//   const params = new URLSearchParams(location.search);

//   if (activePlanDrawer) {
//     const card = journalCards.find((c) => c.id === activePlanDrawer);
//     if (card?.drawerUrl) {
//       params.set("drawer", card.drawerUrl);
//       navigate(`?${params}`, { replace: false });
//     }
//   } else {
//     params.delete("drawer");
//     navigate(`?${params}`, { replace: false });
//   }
// }, [activePlanDrawer]);



  const activeCard = journalCards.find(card => card.drawerUrl && card.drawerUrl === activePlanDrawer);
  const DrawerComponent = activeCard?.drawerComponent;
  const DrawerTitle = activeCard?.title;
  const DrawerBackgrouncColor = activeCard?.themeColor;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  

  // Use ref to directly manipulate DOM classes - no re-renders
  const headerRef = useRef(null);
  const handleScroll = useCallback((event) => {
    const scrollTop = event.target.scrollTop;
    if (headerRef.current) {
      if (scrollTop > 20) {
        headerRef.current.classList.add('plan-header-translucent');
        headerRef.current.classList.remove('plan-header-solid');
        headerRef.current.style.backgroundColor = DrawerBackgrouncColor?.replace(', 1)', ', 0.7)');
      } else {
        headerRef.current.classList.add('plan-header-solid');
        headerRef.current.classList.remove('plan-header-translucent');
        headerRef.current.style.backgroundColor = DrawerBackgrouncColor;
      }
    }
  }, [DrawerBackgrouncColor]); // Empty dependency array since we're using refs



  // Shared drawer content
  const renderDrawerContent = () => (
    <div className="drawer-container" style={{ overflow: 'auto' }} onScroll={handleScroll}>
      <div 
        ref={headerRef} 
        className="sticky-header plan-header-solid"
        style={{ backgroundColor: DrawerBackgrouncColor }}
      >
        <div className="header-content">
          <div className="header-back">
            <button
              onClick={() => { setActivePlanDrawer(null) }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <ArrowBackIcon sx={{ fill: "#ffffffff", fontSize: "28px" }} />
            </button>
          </div>
          <div className="header-left">
            <h2 className="header-title">{DrawerTitle}</h2>
          </div>
        </div>
      </div>

      {DrawerComponent && (
        <DrawerComponent
          activePlanDrawer={activePlanDrawer}
          setActivePlanDrawer={setActivePlanDrawer}
          themeColor={DrawerBackgrouncColor}
        />
      )}
    </div>
  );

  return (
    <>
      <div
        style={{
          padding: '15px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
        }}
      >
        {journalCards.map((card) => (
          <JournalCard
            key={card.id}
            cardId={card.id}
            drawerUrl={card.drawerUrl}
            activePlanDrawer={activePlanDrawer}
            setActivePlanDrawer={setActivePlanDrawer}
            title={card.title}
            goal={card.goal}
            glowStyle={card.glowStyle}
            preview={card.preview}
            fullText={card.fullText}
            visualComponent={card.visualComponent}
            drawerComponent={card.drawerComponent}
          />
        ))}
      </div>

      {/* Mobile: SwipeableDrawer from left */}
      {isMobile ? (
        <Drawer
          anchor="left"
          open={!!activePlanDrawer && !!DrawerComponent}
          onClose={() => setActivePlanDrawer(null)}
          onOpen={() => { }}
          sx={{
            '& .MuiDrawer-paper': {
              backgroundColor: "white",
              borderTopRightRadius: '15px',
              borderBottomRightRadius: '15px',
              height: '100%',
              width: '100%',
      overflow: 'auto',
      overscrollBehaviorX: 'none',
      WebkitOverflowScrolling: 'touch'
            },
          }}
          
        >
          {renderDrawerContent()}
        </Drawer>
      ) : (
        /* Desktop: Centered Modal */
        <Modal
          open={!!activePlanDrawer && !!DrawerComponent}
          onClose={() => setActivePlanDrawer(null)}
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '700px',
            maxWidth: '100%',
            height: '90vh',
            bgcolor: 'white',
            borderRadius: '15px',
            overflow: 'auto',
            boxShadow: 24,
            outline: 'none'
          }}>
            {renderDrawerContent()}
          </Box>
        </Modal>
      )}
    </>
  );
}